import { withErrorBoundary } from "@sentry/nextjs";
import { FC } from "react";
import styled from "styled-components";

interface ToggleProps {
  checked: boolean;
  name: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (name: string, newCheckedValue: boolean) => void;
}

export const ToggleSwitch: FC<ToggleProps> = withErrorBoundary(({ checked, onChange, name }) => {
  const handleOnChange = () => {
    onChange(name, !checked);
  };

  return (
    <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
      <p>{name}</p>
      <StyledToggleSwitch htmlFor="checkbox" checked={checked}>
        <input id="checkbox" type="checkbox" checked={checked} onChange={handleOnChange} />
      </StyledToggleSwitch>
    </div>
  );
}, {});

const StyledToggleSwitch = styled.label<{ checked: boolean }>`
  cursor: pointer;
  text-indent: -9999px;
  width: 40px;
  height: 18px;
  display: block;
  border-radius: 100px;
  position: relative;
  background: ${({ checked, theme }) => (checked ? theme.colors.green : theme.colors.subdued)};

  &::after {
    content: "";
    position: absolute;
    top: 0;
    width: 18px;
    height: 18px;
    left: ${({ checked }) => (checked ? "21px" : "calc(30% - 11px)")};
    background: #fff;
    border-radius: 90px;
    transition: 0.3s;
  }
`;
